module.exports = __webpack_public_path__ + "img/Vue-Covid19TestApp-mobile.08891729.png";